import { createAction } from 'redux-actions'

export const closeHeaderSystemAlertState = createAction('HEADER_SYSTEM_ALERT/CLOSE')
export const openHeaderSystemAlertState = createAction('HEADER_SYSTEM_ALERT/OPEN')
